import { Inject, Injectable } from '@angular/core';
import { CaptureSettingsMerchantTreeDto } from '@up/data';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError as observableThrowError } from "rxjs/internal/observable/throwError";
import { ENV_OPTIONS } from "@up/shared/injection-tokens";

@Injectable({
  providedIn: 'root'
})
export class CaptureSettingsMerchantApiService {
  apiEndPoint = '/capture-settings-merchant';
  baseApiUrl = this.environmentOptions.apiUrl;

  constructor(
      @Inject(ENV_OPTIONS) private environmentOptions: any,
      protected httpClient: HttpClient) {
    this.apiEndPoint = '/capture-settings-merchant';
  }

  private getFullUrl(): string {
    return this.baseApiUrl + this.apiEndPoint;
  }

  private handleError(res: HttpErrorResponse | any) {
    console.error(res?.error || res?.body?.error);
    return observableThrowError(res.error || 'Server error');
  }

  getCoreFunctionalitySettingsTreeByMerchantIdentifier(
      merchantIdentifier: string | number,
      featureType: 'digital-receipt' | 'customer-connect'
  ): Observable<CaptureSettingsMerchantTreeDto[]> {
    const url = this.getFullUrl() + `/core-functionality/${featureType}/${merchantIdentifier}`;

    return this.httpClient
        .get<CaptureSettingsMerchantTreeDto[]>(url)
        .pipe(catchError(this.handleError));
  }
}